// extracted by mini-css-extract-plugin
export default {"container":"MediaLibrarySelect_container__bnImS","icon":"MediaLibrarySelect_icon__BV7tt"};